module.exports = __webpack_public_path__ + "static/devera-99fbd891eaa3ab96d5e4d38d1fccaedf.png";